<!--
 * @Author: 秦少卫
 * @Date: 2024-12-19 09:26:13
 * @LastEditors: 秦少卫
 * @LastEditTime: 2024-12-19 09:45:39
 * @Description: 登录提示
-->

<template>
  <div class="login-tip">
    <Button type="text" @click="shwoLogin">{{ $t('myMaterial.pleaseLoginFirst') }}</Button>
  </div>
</template>
<script setup name="Zoom">
import useSelect from '@/hooks/select';
const { appEmit } = useSelect();
const shwoLogin = () => {
  appEmit.emit('showLogin');
};
</script>
<style scoped lang="less">
.login-tip {
  padding: 10px;
  text-align: center;
}
</style>
